import BaseModal from 'components/Modals/BaseModal';
import { Button } from 'react-bootstrap';

const AssociationConfirmationModal = ({ show, updates = [], isSaving, onCancel, onConfirm }) => {
  // Level 3: the device/group settings modal and Audio Manager are below this confirmation.
  return (
    <BaseModal
      show={show}
      handleShow={onCancel}
      size="lg"
      centered
      scrollable
      title="Confirm audio associations"
      closeButton={false}
      backgroundColor="var(--bs-body-bg)"
      borderWidth="1px"
      borderColor="var(--bs-secondary)"
      stackLevel={3}
    >
      <div className="d-flex flex-column gap-4" aria-busy={isSaving}>
        <p className="mb-0">Apply these audio association changes?</p>
        <div className="d-flex flex-column gap-3 overflow-auto customScrollbar-Y">
          {updates.map((update) => (
            <section key={update.audioId} aria-label={update.audioName}>
              <h5>{update.audioName}</h5>
              {update.addedDeviceNames.length > 0 && (
                <p className="mb-1">Add to: {update.addedDeviceNames.join(', ')}</p>
              )}
              {update.removedDeviceNames.length > 0 && (
                <p className="mb-1">Remove from: {update.removedDeviceNames.join(', ')}</p>
              )}
            </section>
          ))}
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <Button variant="dark" className="px-4 rounded-3" onClick={onCancel} disabled={isSaving}>
            Go Back
          </Button>
          <Button
            variant="primary"
            className="px-4 rounded-3"
            onClick={onConfirm}
            disabled={isSaving}
          >
            {isSaving ? 'Saving…' : 'Yes'}
          </Button>
        </div>
      </div>
    </BaseModal>
  );
};

export default AssociationConfirmationModal;
